/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'Ó¨Ð½Ó©Ó©Ð´Ó©Ñ',
  now: 'ÐÐ´Ð¾Ð¾',
  backToToday: 'Ó¨Ð½Ó©Ó©Ð´Ó©ÑÐ»Ò¯Ò¯ Ð±ÑÑÐ°Ñ',
  ok: 'Ok',
  clear: 'Ð¦ÑÐ²ÑÑÐ»ÑÑ',
  month: 'Ð¡Ð°Ñ',
  year: 'ÐÐ¸Ð»',
  timeSelect: 'Ð¦Ð°Ð³ ÑÐ¾Ð½Ð³Ð¾Ñ',
  dateSelect: 'ÐÐ³Ð½Ð¾Ð¾ ÑÐ¾Ð½Ð³Ð¾Ñ',
  weekSelect: '7 ÑÐ¾Ð½Ð¾Ð³ ÑÐ¾Ð½Ð³Ð¾Ñ',
  monthSelect: 'Ð¡Ð°Ñ ÑÐ¾Ð½Ð³Ð¾Ñ',
  yearSelect: 'ÐÐ¸Ð» ÑÐ¾Ð½Ð³Ð¾Ñ',
  decadeSelect: 'ÐÑÐ²Ð°Ð½ ÑÐ¾Ð½Ð³Ð¾Ñ',
  yearFormat: 'YYYY',
  dateFormat: 'YYYY/MM/DD',
  dayFormat: 'DD',
  dateTimeFormat: 'YYYY/MM/DD HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Ó¨Ð¼Ð½Ó©Ñ ÑÐ°Ñ (PageUp)',
  nextMonth: 'ÐÐ°ÑÐ°Ð° ÑÐ°Ñ (PageDown)',
  previousYear: 'Ó¨Ð¼Ð½Ó©Ñ Ð¶Ð¸Ð» (Control + left)',
  nextYear: 'ÐÐ°ÑÐ°Ð° Ð¶Ð¸Ð» (Control + right)',
  previousDecade: 'Ó¨Ð¼Ð½Ó©Ñ Ð°ÑÐ²Ð°Ð½',
  nextDecade: 'ÐÐ°ÑÐ°Ð° Ð°ÑÐ²Ð°Ð½',
  previousCentury: 'Ó¨Ð¼Ð½Ó©Ñ Ð·ÑÑÐ½',
  nextCentury: 'ÐÐ°ÑÐ°Ð° Ð·ÑÑÐ½'
};
